import { Flex } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import { Modal } from "antd";
import colors from "core/resources/theme/colors";
import FooterModal from "ui/components/Button/FooterModal";

interface ModalConfirmarPortariaProps {
  autorizacaoId: string;
  visible: boolean;
  onConfirm?: () => any;
  onInputData?: () => any;
  onClose: () => any;
  disableConfirmar?: boolean;
  isLoadingConfirmar?: boolean;
}

function ModalConfirmarPortaria({
  visible,
  onConfirm,
  onInputData,
  onClose,
  disableConfirmar,
  isLoadingConfirmar,
}: ModalConfirmarPortariaProps) {
  return (
    <Modal
      width={"750px"}
      footer={
        <FooterModal
          showRegisterAnother={false}
          registerAnother={false}
          onSubmit={disableConfirmar ? undefined : onConfirm}
          hidePrimaryButton={disableConfirmar}
          isDisabled={disableConfirmar}
          isLoadingSave={isLoadingConfirmar}
          onClose={onClose}
          primaryButtonText={"Confirmar"}
          buttonCancelarText="Voltar"
          primaryButtonBgColor={colors.green500}
          secondaryButtonText={"Inserir dados da pessoa"}
          onSecondaryClick={onInputData}
          showBorderTop={false}
        />
      }
      visible={visible}
      onCancel={onClose}
    >
      <Flex flexDir="column">
        <Heading mb={4} size="md">
          O que deseja fazer?
        </Heading>
      </Flex>
    </Modal>
  );
}

export default ModalConfirmarPortaria;
